<template>
  <div>
    <v-layout justify-center>
      <v-flex>
        <v-card ref="form">
          <v-toolbar color="primary" dark>
            <v-toolbar-title>
              <span v-if="!!id">Изменить научную специальность</span>
              <span v-else> <div>Создать научную специальность</div></span>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-toolbar-items>
                <v-btn @click="closeDialog" class="pa-0 ma-0" dark flat icon>
                  <v-icon>close</v-icon>
                </v-btn>
              </v-toolbar-items>
            </v-toolbar-items>
          </v-toolbar>
          <v-card-text>

            <v-autocomplete
              :error="hasError('scientificIndustry')"
              :error-messages="getError('scientificIndustry')"
              :items="selectors.scientificIndustry"
              label="Отрасль науки"
              v-model="value.scientificIndustry"
              no-data-text ="Нет данных"
            ></v-autocomplete>

            <v-autocomplete
              :error="hasError('scientificSpecialty')"
              :error-messages="getError('scientificSpecialty')"
              :items="selectors.scientificSpecialty"
              label="Научная специальность"
              v-model="value.scientificSpecialty"
              no-data-text ="Нет данных"
            ></v-autocomplete>
            <v-alert
              :value="hasError('detail')"
              type="error"
            >
              {{getError('detail')}}
            </v-alert>
            <v-btn @click="apply" color="primary">Сохранить</v-btn>
          </v-card-text>
          <v-divider class="mt-5"></v-divider>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
    // import urls from "../../../../../urls"
    import UserDataFormMixin from '../../../../../mixins/UserDataFormMixin'
    import {makeGetRequest} from "../../../../../helper";

    export default {
        name: "Scientific_field",
        mixins: [UserDataFormMixin],
        props: {
            id: Number,
        },
        data() {
            return {
                URL_CREATE: process.env.VUE_APP_API_HOST +"council/admin/core/models/scientific_field/",
                URL_UPDATE:  process.env.VUE_APP_API_HOST +"council/admin/core/models/scientific_field/<id>/",
                selectors:{
                    scientificSpecialty:[],
                    scientificIndustry:[]
                },
                value: {
                    id: this.id || '',
                    scientificSpecialty: this.scientificSpecialty || null,
                    scientificIndustry: this.scientificIndustry || null,
                },
                // errors: {}
            }
        },

        methods: {
            closeDialog() {
                this.$emit('ended', '')
            },
            loadSelector(data, url) {
                let sys = true
                makeGetRequest(url).then(resp => {
                    if (!resp.ok) {
                        sys = false
                    }
                    return resp.json()
                }).then(json => {
                    this.selectors[data] = json
                })
            },
            text: item => item.name[0].text,

        },
        created() {
            let url =  process.env.VUE_APP_API_HOST +"council/admin/core/selectors/scientific_specialty/"
            this.loadSelector("scientificSpecialty", url)

            url =  process.env.VUE_APP_API_HOST +"council/admin/core/selectors/scientific_industry/"
            this.loadSelector("scientificIndustry", url)
            if(this.id !== undefined){
                makeGetRequest(this.URL_UPDATE.replace("<id>",this.id)).then(resp => {
                    return resp.json()
                }).then(json => {
                    this.value.scientificSpecialty = json.scientificSpecialty.id
                    this.value.scientificIndustry = json.scientificIndustry.id
                })
            }

        }
    }

</script>

<style scoped>

</style>
